// src/com/auto_plan_bind_store_set/AutoPlanBindStoreSetGql.js
import { gql } from "@apollo/client";

/* ************************************************
 * AUTO_PLAN_BIND_STORE_SET Apollo Graphql
 * Project: NewTOP for cloud
 * 2024-10-15 15:05:00 using DbdbTap
 ************************************************ */

const AUTO_PLAN_BIND_STORE_SET_LIST_PART = gql`
fragment AutoPlanBindStoreSetListPart on AutoPlanBindStoreSet {
    groupOrderNum
    dcCd
    setOrderNum
    storeId
    condiVehTypeId
    condiPtCnt
    dcName
    storeName
    vehTypeName
    regDate
    regUser
    regUserName
}
`;

/* const AUTO_PLAN_BIND_STORE_SET_NO_LIST_PART = gql`
fragment AutoPlanBindStoreSetNoListPart on AutoPlanBindStoreSet {
}
`; */


export const LIST_AUTO_PLAN_BIND_STORE_SET = gql`
${AUTO_PLAN_BIND_STORE_SET_LIST_PART}
query ListAutoPlanBindStoreSet($groupOrderNum:Int) {
    autoPlanBindStoreSetList(groupOrderNum:$groupOrderNum) {
        ...AutoPlanBindStoreSetListPart
    }
}
`;

/* 
export const GET_AUTO_PLAN_BIND_STORE_SET = gql`
${AUTO_PLAN_BIND_STORE_SET_LIST_PART}
${AUTO_PLAN_BIND_STORE_SET_NO_LIST_PART}
query GetAutoPlanBindStoreSet($groupOrderNum:Int!, $dcCd:String!, $setOrderNum:Int!) {
    autoPlanBindStoreSetItem(groupOrderNum:$groupOrderNum, dcCd:$dcCd, setOrderNum:$setOrderNum) {
        ...AutoPlanBindStoreSetListPart
        ...AutoPlanBindStoreSetNoListPart
    }
}
`;
*/


export const ADD_AUTO_PLAN_BIND_STORE_SET = gql`
mutation AddAutoPlanBindStoreSet($autoPlanBindStoreSet:InputAutoPlanBindStoreSetAdd!) {
	autoPlanBindStoreSetAdd(autoPlanBindStoreSet: $autoPlanBindStoreSet) {
		ok
		message
	}
}
`;

/**
 * Turn the list of AutoPlanBindStoreSet into a list of
 * autoPlanBindGroup having a list of stores.
 * Group should have {groupOrderNum, dcCd, condiVehTypeId, condiPtCnt, vehTypeName}
 * Each store should have {setOrderNum, storeId, storeName}
 * 중복여부를 확인할 수 있는 Key 생성.
 * @param {*} list 
 */
export function makeAutoPlanBindGroupSet(list) {
    const groupMap = {};
    list.forEach(item => {
        const {
            groupOrderNum, dcCd, dcName, condiVehTypeId, condiPtCnt, vehTypeName,
            setOrderNum, storeId, storeName, regUserName, regDate
        } = item;

        if(!groupMap[groupOrderNum]) {
            //const bindKey = `${condiVehTypeId}`;
            groupMap[groupOrderNum] = {
                //bindKey: bindKey,
                groupOrderNum, dcCd, dcName, condiVehTypeId, condiPtCnt, 
                vehTypeName, regUserName, regDate,
                storeSetList: []
            };
        }
        groupMap[groupOrderNum].storeSetList.push({
            setOrderNum, storeId, storeName
        });
    });
    /* const array = Object.values(groupMap);
    for(const group of array) {
        let bindKey = group.bindKey;
        // add storeKeys to bindKey
        group.storeSetList.forEach(store => {
            bindKey += `:${store.storeId}`;
        });
        group.bindKey = bindKey;
    }

    return array; */
    return Object.values(groupMap);
}

/**
 * Make the list made by makeAutoPlanBindGroupSet() into a map
 * for duplication check
 * @param {Array} list 
 */
export function getAutoPlanBindGroupMap(list) {
    // result: {key: {size: number, stores: {storeId: true, ...}, groups: [groupOrderNum,...]}}
    // key: condiVehTypeId:storeId1:storeId2:...
    const map = {};
    list.forEach(group => {
        let key = `${group.condiVehTypeId}`;
        const obj = {size: group.storeSetList.length, stores: {}, groups: [group.groupOrderNum]};
        group.storeSetList.forEach(store => {
            key += `:${store.storeId}`;
            obj.stores[store.storeId] = true;
        });
        if(map[key]) {
            map[key].groups.push(group.groupOrderNum);
        }
        else map[key] = obj;
    });
    return map;
}

export const AutoPlanBindDupStatus = {NotExist: 0, Exist: 1, Same: 2};

export function checkAutoPlanBindGroupDuplication(groupMap, groupOrderNum, vehTypeId, stores) {
    let key = `${vehTypeId}`;
    stores.forEach(store => {
        key += `:${store.storeId}`;
    });
    if(groupMap[key]) {
        if(groupOrderNum) {
            // 포함하고 있으면 그 자신이기 때문에 중복이 아님.
            if(!groupMap[key].groups.includes(groupOrderNum)) return AutoPlanBindDupStatus.Same;
        }
        else return AutoPlanBindDupStatus.Same;
    }

    for(const groupKey of Object.keys(groupMap)) {
        const group = groupMap[groupKey];
        if(group.size === stores.length) {
            let existCount = 0;
            for(const store of stores) {
                if(group.stores[store.storeId]) existCount++;
            }
            if(existCount === stores.length) {
                if(groupOrderNum) {
                    // 포함하고 있으면 그 자신이기 때문에 중복이 아님.
                    if(!group.groups.includes(groupOrderNum)) return AutoPlanBindDupStatus.Exist;
                }
                else return AutoPlanBindDupStatus.Exist;
            }
        }
    }

    return AutoPlanBindDupStatus.NotExist;
}
